<agr-dialog [data]="data" (cancel)="cancel()" (confirm)="confirmDeliveryDate()">
  <app-product-delivery-moment
    [skuId]="data.repeatOrderItem?.internalId"
    [initialFlexibility]="chosenFlexibility"
    [deliveryInformation]="data.deliveryInformation"
    (deliveryInformationIsValid)="handleDeliveryInformationIsValidChange($event)"
    [allowedFlexibility]="orderingInformation?.flexibility ?? 0"
    (deliveryInformationChanged)="handleDeliveryInformationChange($event)"
  >
  </app-product-delivery-moment>
</agr-dialog>
